// src/components/dashboards/Vendor/adminvendors/VendorService.js

import axios from "axios";

export const createVendorApi = (token) => {
  return axios.create({
    baseURL: "/api/admin",
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const loadVendors = async (api, setVendors) => {
  const res = await api.get("/vendors");
  setVendors(res.data);
};

export const saveVendor = async (api, vendorForm) => {
  const payload = {
    ...vendorForm,
    location: {
      address: vendorForm.address,
      city: vendorForm.city,
      latitude: vendorForm.latitude,
      longitude: vendorForm.longitude,
    },
  };

  if (vendorForm._id) {
    return api.put(`/vendors/${vendorForm._id}`, payload);
  }

  return api.post("/vendors", payload);
};

export const deleteVendor = async (api, id) => {
  return api.delete(`/vendors/${id}`);
};
